<template>
<div>
  <el-row type="flex" class="title-bar" :style="'justify-content:' + (operationFlag ? 'flex-end;' : 'space-between;')">
    <w-perf-analysis-time-info v-if="!operationFlag" :ref="timeInfoRef" :checkDatetime="checkDatetime" @change="onTimeTypeChange" @reload="onCurrentDataReLoad"/>
    <span>
      <w-header-search-button @click="onSearchToolButtonClick"></w-header-search-button>
    </span>
  </el-row>
  <el-table-wrapper v-loading="isLoading" :data="tableData" :columns="columns" :pagination="true" :column-default="columnDefault" :show-custom-header="true" :show-search-tool="showSearchTool">
  </el-table-wrapper>
</div>
</template>

<script>
import isNil from 'lodash/isNil';
import databaseTableInfoAPI from '@/api/performance/database/database-table-info';
import { analysisTimeType } from '@/constants/performance';
import { convertValuByUnit } from '@/utils/number';
import msgUtil from '@/utils/message';
import { EMPTY_TEXT, getValueAfterCheckEmpty } from '@/utils/string';
import { columnDefault } from '@/constants/table';
import WPerfAnalysisTimeInfo from '@/views/performance/node/analysis/components/PerfAnalysisTimeInfo';
import AnalysisTableMixin from '@/mixins/performance/analysis-table-ex';

export default {
  name: 'WDemonprocessMsSqlTable',
  mixins: [AnalysisTableMixin],
  components: {
    WPerfAnalysisTimeInfo,
  },
  data() {
    return {
      isLoading: false,
      checkDatetime: null,
      showSearchTool: false,
      columnDefault,
      tableData: [],
      columns: [
        { prop: 'SPID', label: 'SPID', sortable: true, searchable: true, formatter: this.getTableValueAfterCheckEmpty },
        { prop: 'LOGINAME', label: '사용자', sortable: true, searchable: true, formatter: this.getTableValueAfterCheckEmpty },
        { prop: 'STATUS', label: '프로세스 상태', sortable: true, searchable: true, formatter: this.getTableValueAfterCheckEmpty },
        { prop: 'CMD', label: '명령어', sortable: true, searchable: true, formatter: this.getTableValueAfterCheckEmpty },
        { prop: 'LASTWAITTYPE', label: '대기 유형', sortable: true, searchable: true, formatter: this.getTableValueAfterCheckEmpty },
        { prop: 'PHYSICAL_IO', label: '물리적 I/O', sortable: true, formatter: this.getTableValueAfterCheckEmpty },
        { prop: 'MEMUSAGE', label: '메모리 사용량(byte)', sortable: true, formatter: this.formatterForByte, width: 140 },
        { prop: 'LOGIN_TIME', label: '로그인 시각', sortable: true, searchable: true, seatchType: 'date', formatter: this.getTableValueAfterCheckEmpty },
        { prop: 'OPEN_TRAN', label: '트랜잭션 수', sortable: true, formatter: this.formatterForCount },
        { prop: 'LAST_BATCH', label: '마지막 수행 시각', sortable: true, searchable: true, width: 140, seatchType: 'date', formatter: this.getTableValueAfterCheckEmpty },
      ],
    };
  },
  methods: {
    /**
     * 데몬 프로세스를 조회한다.
     * @author Ju
     */
    loadData() {
      const params = {
        objId: this.selectedNode.obj.objId,
        baselineDatetime: this.operationFlag ? new Date().getTime() : this.plotLineDatetime,
        managetypeId: 'DBMS',
      };
      if (this.timeType === analysisTimeType.CURRENT.value || this.operationFlag) {
        // 현재
        params.queryId = 'DBMSProcessInfo';
        this.isLoading = true;
        databaseTableInfoAPI.getCurrentDemonprocessList(params).then((result) => {
          if (result.data.success) {
            this.tableData = result.data.data;
          } else {
            this.failToLoadData();
          }
        }).catch(() => {
          this.failToLoadData();
        }).finally(() => {
          this.isLoading = false;
        });
      } else {
        // 스냅샷
        this.isLoading = true;
        databaseTableInfoAPI.getDemonprocessMssqlList(params).then((result) => {
          if (result.data.success === true) {
            const snapshotData = result.data.data;
            this.tableData = snapshotData.snapshotDoc;
            this.checkDatetime = snapshotData.timestamp;
          } else {
            this.failToLoadData();
          }
        }).catch(() => {
          this.failToLoadData();
        }).finally(() => {
          this.isLoading = false;
        });
      }
    },
    /**
     * 데이터 조회 실패 처리
     * @author Ju
     * @return {[type]} [description]
     */
    failToLoadData() {
      this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '데몬 프로세스', false));
    },
    /**
     * count formatter
     * @author Ju
     * @param  {[type]} row    [description]
     * @param  {[type]} column [description]
     * @param  {[type]} value  [description]
     * @return {[type]}        [description]
     */
    formatterForCount(row, column, value) {
      return isNil(value) ? EMPTY_TEXT : convertValuByUnit(value, null, true);
    },
    /**
     * byte formatter
     * @author Ju
     * @param  {[type]} row    [description]
     * @param  {[type]} column [description]
     * @param  {[type]} value  [description]
     * @return {[type]}        [description]
     */
    formatterForByte(row, column, value) {
      return isNil(value) ? EMPTY_TEXT : convertValuByUnit(value, 'Byte', false, false, true);
    },
    /**
     * 테이블 데이터 빈값 확인
     * @author Yang
     * @param  {Object} row
     * @param  {Object} column
     * @param  {String/Number} valu
     */
    getTableValueAfterCheckEmpty(row, column, value) {
      return getValueAfterCheckEmpty(value);
    },
    /**
     * 검색 버튼 클릭 이벤트 핸들러
     * @author Ju
     * @return {[type]} [description]
     */
    onSearchToolButtonClick() {
      this.showSearchTool = !this.showSearchTool;
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/performance/node/analysis/database/components/table/DemonProcess/DemonprocessMsSqlTable.vue